import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PolicyCommonCoverables from '../PolicyCommonCoverables/PolicyCommonCoverables';
import metadata from './PolicyCoverages.metadata.json5';

function PolicyCoverages(props) {
    const { value: policy } = props;

    if (_.isEmpty(policy)) {
        return null;
    };

    const overrides = {
        policyVehiclesDriversInfoComponent: {
            visible: false
        },
        policyHomeOwnersInfoComponent: {
            visible: false
        },
        genericCoveragesComponent: {
            visible:!_.isEmpty(policy.coverables)
        }
    };

    const resolvers = {
        resolveComponentMap: {
            genericcoveragecomponent: PolicyCommonCoverables
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policy}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

PolicyCoverages.propTypes = {
    value: PropTypes.shape({})
};

PolicyCoverages.defaultProps = {
    value: {
        coverables: []
    }
};

export default PolicyCoverages;
